import { useQuery } from 'react-query';
import { getPrivateApi } from '../services/api';
import { queryKeys } from '../services/query-key/query-keys';

export function useDepositTo(customerId?: string) {
  return useQuery(queryKeys.depositTo(customerId), async () => {
    const api = getPrivateApi();
    const response = await api.getDepositTo({ customerId });
    return {
      depositToAccounts: response.depositToAccounts,
      defaultDepositToAccountId: response.defaultDepositToAccountId,
    };
  });
}
